import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpHeaders,
  HttpErrorResponse,
  HttpClient
} from '@angular/common/http';
import { BehaviorSubject, Observable, throwError,interval } from 'rxjs';
import { CONSTANTS } from '../config/constants';
import { LocalStorageService } from './local-storage.service';
import { catchError, filter, switchMap, take, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { LoginService } from '../authentication/login.service';

@Injectable()
export class RequestInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(private localStorageService: LocalStorageService,
              private authService: LoginService,
              public router: Router,
              private httpClient: HttpClient) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let token:any= this.localStorageService.getToken();
    var clonedRequest:any;
    if(token){
      clonedRequest=this.addTokenHeader(request,token);
    }else{
      clonedRequest = request.clone({
        headers: new HttpHeaders({
              "Content-Type": "application/json",
              "x-api-key": CONSTANTS.APP.API_KEY_HEADER,
            })
        });
    }  
    //return next.handle(clonedRequest);
    return next.handle(clonedRequest).pipe( tap(() => {},
            (error: any) => {
            if (error instanceof HttpErrorResponse) {
              if (error.status == 200) {
                  return;
              }
              //refresh token 401 error
              if (error instanceof HttpErrorResponse && clonedRequest.url.includes('token/refresh') && error.status === 401) {
                    this.localStorageService.signOut();
                    this.router.navigate(['login']).then(() => {
                      //window.location.reload();
                    });
                    return throwError(error);
              }
              //other method 401 error
              if (error instanceof HttpErrorResponse && !clonedRequest.url.includes('login') && error.status === 401) {
                return this.handle401Error(clonedRequest, next);
                /*this.localStorageService.signOut();
                this.router.navigate(['login']).then(() => {
                  window.location.reload();
                });
                return throwError(error);*/
              }
              return throwError(error);
            }
          }
      ))as Observable<HttpEvent<any>>;
  }

  /**
    * handle 401 error
    * @param request
    * @param next
    * @returns
    */
  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);
      const token = this.localStorageService.getRefreshToken();
      if (token){
        let refreshDto={refreshtoken : token};
       return this.authService.refreshToken(refreshDto).pipe(
          switchMap((response: any) => { 
           console.log("switchmap loop"); 
           console.log(response);
            this.isRefreshing = false;
            this.localStorageService.saveToken(response.data.accesstoken);
            this.localStorageService.saveRefreshToken(response.data.refreshtoken);
            this.refreshTokenSubject.next(response.data.accesstoken);
            return next.handle(this.addTokenHeader(request, response.data.accesstoken));
          }),
          catchError((err) => { 
           console.log("in error"+err);
            this.isRefreshing = false;
            this.localStorageService.signOut();
            this.router.navigate(['login']);
            return throwError(err);
          })
          
       ).subscribe( (response:any) => {
        console.log("subscribe loop");
         /* this.isRefreshing = false;
          this.localStorageService.saveToken(response.data.accesstoken);
          this.refreshTokenSubject.next(response.data.accesstoken);
          return next.handle(this.addTokenHeader(request, response.data.accesstoken));*/
      });
      }else{
        this.isRefreshing = false;
        this.localStorageService.signOut();
        this.router.navigate(['login']);
      }
    }
    return this.refreshTokenSubject.pipe(
      filter(token => token !== null),
      take(1),
      switchMap((token:any) => {
           console.log("last");
           return next.handle(this.addTokenHeader(request, token))
      })
    );
  }

  /**
   * add token header
   * @param request 
   * @param token 
   * @returns 
   */
  private addTokenHeader(request: HttpRequest<any>, token: string) {
        return request.clone({
          headers: new HttpHeaders({
                "Authentication":token,
               // "Content-Type": "multipart/form-data;boundary {}",
                "x-api-key":CONSTANTS.APP.API_KEY_HEADER,
              })
          });
      }
          
}

// import { HTTP_INTERCEPTORS, HttpEvent, HttpErrorResponse, HttpResponse, HttpEventType } from '@angular/common/http';
// import { Injectable } from '@angular/core';
// import { HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
// import { BehaviorSubject, Observable, throwError } from 'rxjs';
// import { catchError, filter, switchMap, take, tap } from 'rxjs/operators';
// import { Router } from '@angular/router';
// import { LocalStorageService } from './local-storage.service';
// import { LoginService } from '../authentication/login.service';
// import { CONSTANTS } from '../config/constants';
// const TOKEN_HEADER_KEY = 'Authentication';  // for back-end
// @Injectable()
// export class RequestInterceptor implements HttpInterceptor {
//   private isRefreshing = false;
//   private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
//   constructor(private localStorageService: LocalStorageService,
//               private authService: LoginService,
//               public router: Router) { }
//   /**
//    * call intercept method
//    * @param req
//    * @param next
//    * @returns
//    */
//   intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<Object>> {
//     if (!window.navigator.onLine) {
//         alert("No Internet connection!");
//     }
   
//     let authReq = req;
//     const token = this.localStorageService.getToken();
//     if (token != null) {
//       authReq = this.addTokenHeader(req, token);
//     }

//     return next.handle(authReq).pipe(
//       tap((event: HttpEvent<any>) => {
//       }),
//       catchError(error => {
//       //refresh token 401 error
//       if (error instanceof HttpErrorResponse && authReq.url.includes('update-jwt-token') && error.status === 401) {
//             this.isRefreshing = false;
//             this.localStorageService.signOut();
//             this.router.navigate(['login']).then(() => {
//               window.location.reload();
//             });
//             return throwError(error);
//       }
//       //other method 401 error
//       if (error instanceof HttpErrorResponse && !authReq.url.includes('login') && error.status === 401) {
//          return this.handle401Error(authReq, next);
//       }
//       return throwError(error);
//     })) as Observable<HttpEvent<any>>;
//   }
//   /**
//    * handle 401 error
//    * @param request
//    * @param next
//    * @returns
//    */
//   private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
//     if (!this.isRefreshing) {
//       this.isRefreshing = true;
//       this.refreshTokenSubject.next(null);
//       const token = this.localStorageService.getRefreshToken();
//       if (token){
//        return this.authService.refreshToken(token).pipe(
//           switchMap((token: any) => {
//             this.isRefreshing = false;
//             this.localStorageService.saveToken(token.data.access_token);
//             this.refreshTokenSubject.next(token.data.access_token);
//             return next.handle(this.addTokenHeader(request, token.data.access_token));
//           }),
//           catchError((err) => {
//             this.isRefreshing = false;
//             this.localStorageService.signOut();
//             //this.router.navigate(['login']);
//             window.location.href="/home";
//             return throwError(err);
//           })
//        );
//       }else{
//         this.isRefreshing = false;
//         this.localStorageService.signOut();
//         //this.router.navigate(['login']);
//         window.location.href="/home";
//       }
//     }
//     return this.refreshTokenSubject.pipe(
//       filter(token => token !== null),
//       take(1),
//       switchMap((token) => next.handle(this.addTokenHeader(request, token)))
//     );
//   }
//   /**
//    * add token in header for every request
//    * @param request
//    * @param token
//    * @returns
//    */
//   private addTokenHeader(request: HttpRequest<any>, token: string) {
//     return request.clone({ headers: request.headers.set(TOKEN_HEADER_KEY, token)
//                                                    .set('x-api-key', CONSTANTS.APP.API_KEY_HEADER)
//                          });
//   }
// }









